module.exports = __webpack_public_path__ + "img/C4.afd48c7c.png";